import { render } from "./MainSection.vue?vue&type=template&id=241fb5d4&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=241fb5d4&scoped=true&lang=css"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241fb5d4"]])

export default __exports__